(function(algolia) {
  'use strict';

  var enabled = algolia.config.analytics_enabled;
  if (!enabled) return;

  window.aa('init', {
    appId: algolia.config.app_id,
    apiKey: algolia.config.search_api_key,
    useCookie: true
  });

  if (window.algoliaUserToken) {
    window.aa('setUserToken', window.algoliaUserToken);
  } else {
    window.aa('getUserToken', null, (err, userToken) => {
      if (err) {
        console.error(err);
        return;
      }
      if (userToken)  {
        window.aa('setUserToken', userToken);
      }
    });
  }

  const localStorageKey = 'algolia_analytics_clicked_objects';

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      var conversionData = data;

      // Changing the event to 'convert' from 'click'
      conversionData.eventName = 'convert';
      // Removing the `positions` property
      delete conversionData.positions;

      // Add the current products data to local storage
      previousClickItems.push(conversionData)
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
    } catch (error) {
      // No need to do anything in this scenario
    }
  };

  /**
   * Try to get the details from local storage for conversion tracking.
   * We're using a try...catch here to handle any possible exceptions resulting
   * from local storage or JSON parsing.
   */
  function trackConversion(event) {
    try {
      // Get any previously stored data.
      const previousClickItemsString = localStorage.getItem(localStorageKey)
      // If data was found, send a conversion event for those products.
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString)
        previousClickItems.forEach((data) => {
          window.aa('convertedObjectIDsAfterSearch', data);
        })
      } else if(event) {
        window.aa('convertedObjectIDs', {
          eventName: 'convert',
          index: algolia.config.index_prefix + 'products',
          objectIDs: [event.target.form.id.value]
        });
      }
    } catch (error) {
      // No need to do anything in this scenario.
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem(localStorageKey)
    } catch (error) {
      // No need to do anything in this scenario.
    }
  }

  // Track a conversion event when clicking the 'add to cart' button.
  // Change the query selector to be the correct one for your theme.
  function addConversionEvents () {
    var addToCartBtns = document.querySelectorAll('#AddToCart');

    addToCartBtns.forEach(function (btn) {
      if (btn.classList.contains('events-added'))
        return;

      btn.classList.add('events-added');
      btn.addEventListener('click', function (e) {
        trackConversion(e);
      });
    })
  }

  algolia.addConversionEvents = addConversionEvents;
  addConversionEvents();
})(window.algoliaShopify);
